var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-bg"},[_c('img',{staticClass:"image-size",attrs:{"src":require("@/static/images/bg-shade3.png")}})])}]

export { render, staticRenderFns }